<template>
  <div class="prize-record-page" v-if="services.length">
    <ul class="rewards">
      <li class="reward" v-for="(reward, idx) in services" :key="idx">
        <div class="main-content">
          <div class="info">
            <div class="name">
              <span>+{{ reward.prize_value }}</span>
              <span>{{ reward.activity_name }}</span>
            </div>
            <div class="time">{{ reward.created_time.substring(0, 16).replace('T', ' ') }}</div>
          </div>

          <div class="tip">
            <div class="receive-button">
              <button
                :class="[reward.receive_code === 'WAIT' ? 'gain-enabled' : 'gain-disabled']"
                :disabled="!(reward.receive_code === 'WAIT')"
                @click="getRedEnv(reward)"
              >
                {{ reward.receive_code === 'WAIT' ? '点击领取' : reward.receive_code_msg }}
              </button>
            </div>
            <div class="expire-time">请{{ getExpireTimeStr(reward.expire_time) }}前领取</div>
          </div>
        </div>
      </li>
      <red-envelope-num-pupop
        :visible="isPupopVisible"
        :errMsg="(prizeRes && prizeRes.msg) || ''"
        @close="close"
        :step="2"
      ></red-envelope-num-pupop>
    </ul>
  </div>
  <p-e-empty-info v-else tip="还没有获得红包哦~"></p-e-empty-info>
</template>

<script lang="ts">
import { DateWrapper } from 'kuaidong-lib'
import { usePage, RedEnvelopeNumPupop, BaseComponent, Component } from 'kuaidong-component'
import { KdNoData } from 'kuaidong-ui'
import { Ref, ref, onMounted, computed } from 'vue'
import { IPrizeRecord } from '@/models/prizerecord'
import { APrize } from 'kuaidong-api'
import { receivePrizeRes } from 'kuaidong-model'
import APrizeRecord from '@/api/APrizeRecord'
import PEEmptyInfo from '@/views/pe-class/components/PEEmptyInfo.vue'

@Component({
  components: {
    RedEnvelopeNumPupop,
    KdNoData,
    PEEmptyInfo,
  },
})
export default class RedEnvListComp extends BaseComponent {
  pageNo = 1
  loading = false

  isPupopVisible = false

  prizeRes: receivePrizeRes | null = null

  rewards: IPrizeRecord[] = []

  get services() {
    return this.rewards.map((reward: IPrizeRecord) => ({
      ...reward,
    }))
  }

  getExpireTimeStr(time: string) {
    return new DateWrapper(time).showMonthDayStr
  }

  async mounted() {
    await this.fetch()
  }

  async fetch() {
    this.loading = true

    const result = await APrizeRecord.getPrizes(this.pageNo)

    if (result?.length) {
      this.rewards = result

      this.loading = false
    } else {
      this.rewards = []

      this.loading = false
    }
  }

  async loadMore() {
    this.pageNo += 1
    this.fetch()
  }

  close() {
    this.isPupopVisible = false
  }

  async getRedEnv(reward: IPrizeRecord) {
    this.prizeRes = await APrize.addPrize(reward.prize_record_id || '')
    if (this.prizeRes.success) {
      this.toast('领取成功')
      await this.fetch()
    } else {
      this.isPupopVisible = true
    }
  }
}
</script>

<style lang="less">
@font-face {
  font-family: 'youshebiaotihei_number';
  src: url('https://crazyrope-video.oss-cn-shanghai.aliyuncs.com/dataupload/batch/1704439301466/dev/tmp/fonts/YouSheBiaoTiHei-2.eot'); /* IE9 */
  src: url('https://crazyrope-video.oss-cn-shanghai.aliyuncs.com/dataupload/batch/1704439301466/dev/tmp/fonts/YouSheBiaoTiHei-2.eot?#iefix')
      format('embedded-opentype'),
    /* IE6-IE8 */
      url('https://crazyrope-video.oss-cn-shanghai.aliyuncs.com/dataupload/batch/1704439301466/dev/tmp/fonts/YouSheBiaoTiHei-2.woff2')
      format('woff2'),
    /* chrome 36+, firefox 39+,iOS 10+, Android 67+ */
      url('https://crazyrope-video.oss-cn-shanghai.aliyuncs.com/dataupload/batch/1704439301466/dev/tmp/fonts/YouSheBiaoTiHei-2.woff')
      format('woff'),
    /* chrome, firefox */
      url('https://crazyrope-video.oss-cn-shanghai.aliyuncs.com/dataupload/batch/1704439301466/dev/tmp/fonts/YouSheBiaoTiHei-2.ttf')
      format('truetype'),
    /* chrome, firefox, opera, Safari, Android, iOS 4.2+ */
      url('https://crazyrope-video.oss-cn-shanghai.aliyuncs.com/dataupload/batch/1704439301466/dev/tmp/fonts/YouSheBiaoTiHei-2.svg#youshebiaotihei_number')
      format('svg'); /* iOS 4.1- */
  font-style: normal;
  font-weight: normal;
}
.prize-record-page {
  padding: 0 20px;
  // min-height: 100vh;
  margin-top: 15px;
  text-align: left;
  background: #fff;
  box-sizing: border-box;

  > .rewards {
    > .reward {
      padding: 22px 0 9px;
      + .reward {
        margin: 12px 0 0 0;
        border-top: #d9d9d9 solid 1px;
      }

      + .kd-no-data {
        margin: 16px 0 0 0;
      }
      > .main-content {
        display: flex;
        justify-content: space-between;
        > .info {
          width: calc(100% - 85px);
          > .name {
            display: flex;
            align-items: center;
            :first-child {
              color: #da242e;
              font-family: youshebiaotihei_number;
              font-size: 22px;
              font-weight: 400;
              line-height: 22px;
              display: inline-block;
              margin-right: 10px;
            }
            :last-child {
              color: #2d2f33;
              font-size: 12px;
              font-weight: 400;
              line-height: 22px;
              opacity: 0.7;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }

          > .time {
            margin-top: 6px;
            color: #2d2f33;
            font-size: 12px;
            font-weight: 400;
            opacity: 0.7;
          }
        }

        > .tip {
          width: 85px;
          flex: 0 0 85px;
          > .receive-button {
            text-align: center;
            > button {
              border-radius: 17px;
              padding: 5px 11px;
              text-align: center;
              font-size: 14px;
              font-weight: 500;
              line-height: 20px;
              color: #fff;
              &.gain-enabled {
                background-color: #2364ea;
              }
              &.gain-disabled {
                background-color: #000;
                opacity: 0.3;
              }
            }
          }
          > .expire-time {
            text-align: center;
            margin-top: 5px;
            color: #2d2f33;
            font-size: 10px;
            font-weight: 400;
            line-height: 14px;
            height: 14px;
            opacity: 0.3;
            white-space: nowrap;
          }
        }
      }
    }

    > .kd-no-data {
      margin-top: 0;
      padding-top: 16px;
    }
  }
}
</style>
